import { MutationTree } from 'vuex';
import { State } from './vm.store';
import store from '@/store/index';
// import * as types from '../mutation-types';
import * as types from '@/store/modules/vm/vm-types';

import { SubTypes } from '@/utils/capabilties/vm/constatnts';
import { PermissionType } from '@/utils/types/global';

const mutations: MutationTree<State> = {
  [types.vmMutations.SET_CURRENT_VM](
    state: State,
    data: { key: String; label: String }
  ) {
    state.currentVm = data;
  },
  [types.vmMutations.SET_CURRENT_VM_SERVICE](
    state: State,
    data: { key: string; label: string; permissions: PermissionType[] },
  ) {
    state.currentVmService = data;
  },
  [types.vmMutations.SET_CURRENT_VM_INSTANCE](
    state: State,
    data: {
      key: String;
      label: String;
      language: String;
      isActive: Boolean;
      availability: any;
      attributes: any[];
    }
  ) {
    if (data && data.key) {
      state.currentVmInstance.key = data.key;
      state.currentVmInstance.label = data.label;
      state.vmIsActive = data.isActive;
      state.vmAvailability = data.availability;
      state.attributes = data.attributes;
    } else {
      state.currentVmInstance.key = '';
      state.currentVmInstance.label = '';
      state.vmIsActive = false;
      state.vmAvailability = 0;
      state.attributes = [];
    }
  },

  // resets to default values on logout
  setDefaultValues(state: State, data: { key: String; label: String }) {
    state.currentVm = {
      key: '',
      label: ''
    };
    state.currentVmService = {
      key: '',
      label: '',
      permissions: [],
    };
    state.vmServices = [];
    state.currentVmInstance.key = '';
    state.currentVmInstance.label = '';
    state.vmIsActive = false;
    state.vmAvailability = 0;
    state.attributes = [];
    // state.vmSubType = SubTypes.WINDOWS;
  },
  setVMServices(state: State, data: any) {
    state.vmServices = data;
    if (
      (!state.currentVm.key && data.length) ||
      state.currentVm.key === 'all'
    ) {
      state.currentVm = data[0];
    }
  },
  //Sets the current service in rootState
  setCurrentVMService(state: State, service: any) {
    state.currentVmService = service;
    store.commit('globalState/app/setUpdateDasboard', service, { root: true });
  },
  //Sets the current service subType
  [types.vmMutations.SET_CURRENT_SUBTYPE](state: State, type: string) {
    // Commit the graph template based on the subtype
    switch (type) {
      case SubTypes.LINUX:
        state.vmSubType = SubTypes.LINUX;

        break;
      case SubTypes.WINDOWS:
        state.vmSubType = SubTypes.WINDOWS;
        break;
      default:
        state.vmSubType = SubTypes.LINUX;
        break;
    }
  }
};

export default mutations;
